

















































import { Component, Vue, Prop, Inject } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IAffiliateProvider } from "@/models/providers/affiliate";
import { IAffiliatePayoutForm } from "@/models/affiliate";
import { IAccount } from "@/models/accounts";
// import { IAffiliatePayoutDestinationsMethods } from "@/models/providers/affiliatePayoutDestinations";
import _ from "@/boot/lodash";

@Component({
  components: {
    "available-commissions": () =>
      import("@/components/app/global/affiliate/availableCommissions.vue"),
    "account-payout-destination-select": () =>
      import(
        "@/components/app/global/affiliate/accountPayoutDestinationSelect.vue"
      ),
    "payout-destinations-provider": () =>
      import(
        "@/components/app/global/affiliate/payoutDestinationsProvider.vue"
      ),
    "client-email-select": () =>
      import("@/components/app/global/fields/clientEmailSelect.vue")
  }
})
export default class CommissionPayoutModal extends Vue {
  // Inject

  @Inject({ from: "affiliateProvider" })
  public readonly $affiliateData!: () => IAffiliateProvider;

  // @Inject({ from: "affiliatePayoutDestinationsProviderMethods" })
  // public $affPDsMethods!: IAffiliatePayoutDestinationsMethods;

  // Props

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  // Data

  public form = this.initForm();
  public isProcessing = false;

  // Computed

  public get affiliateData() {
    return this.$affiliateData();
  }

  // public get isPayPal() {
  //   return this.$affPDsMethods.isPaypal(
  //     this.form.affiliate_payout_destination_id
  //   );
  // }

  public get clientId() {
    return this.affiliateData.affiliate?.account?.clients?.[0].id;
  }

  public get formIsValid() {
    if (_.isEqual(this.form, this.initForm())) return false;
    if (!this.form.affiliate_commission_ids.length) return false;
    return true;
  }

  public get formIsDisabled() {
    return this.isProcessing || !this.formIsValid;
  }

  // Methods

  public initForm(): IAffiliatePayoutForm {
    return {
      affiliate_commission_ids: [],
      affiliate_payout_destination_id:
        this.affiliateData?.affiliate?.account
          ?.affiliate_payout_destination_id || null,
      real_time: true
    };
  }

  public doPayout() {
    const data = { ...this.form };
    if (_.isNull(data.affiliate_payout_destination_id))
      delete data.affiliate_payout_destination_id;
    return this.$store.dispatch(
      `data/${DataModules.AFFILIATES_PAYOUTS}/payout`,
      {
        affiliate_account_id: this.affiliateData.affiliate?.id,
        data
      }
    );
  }

  public async validateBeforeSubmit() {
    if (this.formIsDisabled) return;
    try {
      this.isProcessing = true;
      await this.doPayout();
      this.$emit("close");
      this.$emit("success");
      this.$buefy.toast.open({
        message: this.$t("_sentence.affiliate.payout_successful") as string
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  // @Watch("form", { deep: true })
  // public onFormChange(form: IAffiliatePayoutForm) {
  //   // Remove PayPal email ID
  //   if (!this.isPayPal && !!form.affiliate_payout_paypal_email_id)
  //     this.form.affiliate_payout_paypal_email_id = null;
  // }
}
